import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChildren,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CurrentUser } from "@common/auth/current-user";
import { Settings } from "@common/core/config/settings.service";
import { AppHttpClient } from "@common/core/http/app-http-client.service";
import { ConfirmModalComponent } from "@common/core/ui/confirm-modal/confirm-modal.component";
import { Modal } from "@common/core/ui/dialogs/modal.service";
import { Toast } from "@common/core/ui/toast.service";
import { removeProtocol } from "@common/core/utils/remove-protocol";
import { Paginator } from "@common/shared/paginator.service";
import { BehaviorSubject } from "rxjs";
import { debounceTime, distinctUntilChanged, skip, takeUntil } from "rxjs/operators";
import { IframeClasses, TemplateNames } from "../shared/builder-types";
import { Project } from "../shared/projects/Project";
import { ProjectSettingsModalComponent } from "../shared/projects/project-settings-modal/project-settings-modal.component";
import { ProjectUrl } from "../shared/projects/project-url.service";
import { Projects } from "../shared/projects/projects.service";
import { UserDomainsService } from "./user-domains.service";
import { DnsPopupComponent } from "../shared/projects/dns-popup/dns-popup.component";
import { ProjectStatusText } from "@common/core/ui/common-messages.enum";
import * as moment from "moment-timezone";
import { ProjectSettingsService } from "../shared/projects/project-settings-modal/project-settings.service";
import { MatDialogRef } from "@angular/material/dialog";
import { uniqueId } from "lodash";
import { Unsub } from "../unsub.class";
import { checkWebsitePulishedSuccessfuly } from "../html-builder/utils/create-doc-from-html";

moment.tz.setDefault('America/Los_Angeles');

declare interface ProjectFilters {
  order: string;
  status: string;
  query: string;
}

@Component({
  selector: "dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent extends Unsub implements OnInit {
  @ViewChildren("iframeSection") iframeSection: ElementRef<HTMLIFrameElement>;
  public loading$ = new BehaviorSubject<boolean>(false);
  public projects$ = new BehaviorSubject<Project[]>([]);
  public newProjectDataForModal = new BehaviorSubject<Project>(null);
  private projectPaginator: Paginator<Project>;
  shouldShowNewProjectButton = true;
  currentIframeClass: IframeClasses = "yashClasss";
  public models = new FormGroup({
    query: new FormControl(""),
    order: new FormControl("created_at|desc"),
    published: new FormControl("all"),
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public settings: Settings,
    public currentUser: CurrentUser,
    private projectsApi: Projects,
    private projectSettingsService: ProjectSettingsService,
    private toast: Toast,
    private modal: Modal,
    private projectUrl: ProjectUrl,
    private http: AppHttpClient,
    public userDomains: UserDomainsService
  ) {
    super();
  }

  ngOnInit() {
    this.userDomains.fetch();
    this.route.data.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.projects$.next(data.projects || []);
    });
    this.bindToProjectFilters();
    console.log("current is admin", this.currentUser.isAdmin());

    if (!this.currentUser.isAdmin() && this.projects$.getValue().length > 0) {
      this.shouldShowNewProjectButton = false;
    }
    this.projects$.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      const project = data[0];
      console.log("project detail", project);
      const websitePulishedSuccessfuly =
        project.isSSLConfigured == 1 &&
        project.ssl_exipre_date != null &&
        project.website_publish_status == 1;
      if (!this.currentUser.isAdmin()) {
        if (
          !project.domain_name ||
          (project.dns_update_status == 1 && project.isSSLConfigured == 0) ||
          !websitePulishedSuccessfuly
        ) {
          this.openProjectSettingsModal(project);
        }
      }
    });
    this.newProjectDataForModal.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      if (data) {
        this.modalSectionCode(data);
      }
    });
  }

  checkModalPopup(frame: HTMLIFrameElement) {
    setTimeout(() => {
      console.log("frame", frame);
      const popUp = frame.contentWindow.document.querySelector("#popupModal");
      const pagePopUp =
        frame.contentWindow.document.querySelector("#page-popup");

      if (popUp) {
        popUp.setAttribute("style", "display:none");
      }
      if (pagePopUp) {
        pagePopUp.setAttribute("style", "display:none");
      }
    }, 1000);
  }
  getRandomId() {
    return Math.floor(1000 + Math.random() * 9000);
  }
  getIframeClass(project: Project): IframeClasses {
    let iframeClass: IframeClasses = "yashClasss";

    if ((project.template as TemplateNames) == "yash") {
      iframeClass = "yashClasss";
    } else if ((project.template as TemplateNames) == "shili") {
      iframeClass = "shiliClasss";
    } else if ((project.template as TemplateNames) == "sultan") {
      iframeClass = "sultanClasss";
    } else if ((project.template as TemplateNames) == "gindiantemp") {
      iframeClass = "greatIndiaClass";
    } else if ((project.template as TemplateNames) == "elia") {
      iframeClass = "eliaClass";
    } else if ((project.template as TemplateNames) == "bombay") {
      iframeClass = "bombayClass";
    }

    return iframeClass;
  }

  public openBuilder(project: Project) {
    this.loading$.next(true);
    this.router.navigate(["/design", project.id]).then(() => {
      this.loading$.next(true);
    });
  }
  public getStatus(project: Project) {
    let status = ProjectStatusText.Draft;

    if (
      project.website_publish_status == 1 &&
      project.final_distribution_status == "Deployed"
    ) {
      status = ProjectStatusText.Pubilished;
    } else if (
      (project.cloudfront_status == "InProgress" ||
        project.cloudfront_status == "Deployed") &&
        (project.website_publish_status == 0 ||
        project.website_publish_status == 1) &&
      project.final_distribution_status != "Deployed"
    ) {
      status = ProjectStatusText.InProgress;
    }
    return status;
  }
  public getStatusColor(project: Project) {
    let statusColor = "danger";

    if (project.website_publish_status == 1 &&
      project.final_distribution_status == "Deployed") {
      statusColor = "success";
    } else if (
      (project.cloudfront_status == "InProgress" ||
        project.cloudfront_status == "Deployed") &&
      (project.website_publish_status == 0 ||
        project.website_publish_status == 1) &&
      project.final_distribution_status != "Deployed"
    ) {
      statusColor = "warning";
    } else if (project.domain_name != "") {
      statusColor = "danger";
    }
    return statusColor;
  }

  public getProjectImage(project: Project) {
    return `${this.projectUrl.getBaseUrl(
      project
    )}thumbnail.png?timestamp=${this.getRandomId()}`;
  }

  public getProjectUrl(project: Project, removeProto = false) {
    let url = project.domain_name && checkWebsitePulishedSuccessfuly(project) ? 'https://' + project.domain_name : project.s3_destination_url + '/index.html';
    return url;
  }
  
  modalSectionCode(project: Project) {
    if (this.modal.anyDialogOpen()) {
      this.modal.closeAll();
    }
    const modalId = `dashboard-modal-${uniqueId()}`;
    this.modal
      .open(
        ProjectSettingsModalComponent,
        { project },
        { maxHeight: "90vh", id: modalId }
      )
      .afterClosed().pipe(takeUntil(this.unsubscribe$))
      .subscribe((newProject) => {
        if (!newProject || !newProject.model) return;
        const newProjects = [...this.projects$.value];
        const i = newProjects.findIndex(
          (curr) => curr.id === newProject.model.id
        );
        newProjects[i] = newProject.model;
        this.projects$.next(newProjects);
        this.newProjectDataForModal.next(newProject.model);
      });
  }
  formatDateString(text: string) {
    return moment(text).tz("America/Los_Angeles").format("MM-DD-yyyy");
  }

  public openProjectSettingsModal(project: Project) {
    // get the project details update first
    this.projectsApi.get(project.id).pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.modalSectionCode(data.project.model);
    });
    // if(project.isSSLConfigured == 1){
    //     this.modalSectionCode(project);
    // }else {
    //     // get the project details update first
    //     this.projectsApi.get(project.id).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
    //         this.modalSectionCode(data.project.model);
    //     })

    // }
  }
  public openDnsModal(project: Project) {
    this.modal.open(DnsPopupComponent, { project });
  }
  checkDomainName(text: string) {
    return text ? text.slice(0, -1) : "";
  }
  onUnpublish(project: Project){
    this.modal
      .open(ConfirmModalComponent, {
        title: "Unpublish Project",
        body: "Are you sure you want to unpublish this project?",
        ok: "Unpublish",
      })
      .afterClosed().pipe(takeUntil(this.unsubscribe$))
      .subscribe(confirmed => {
        if(confirmed){
          console.log('start unpublish');
          this.loading$.next(true);
          this.projectsApi.unpublish(project.id).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
            console.log('unpublish data', data);
            this.loading$.next(false);
            this.toast.open("Project unpublished");
          const newProjects = this.projects$.value.map(item => item.id == data.project.model.id ? {...item,...data.project.model}: item);
          this.projects$.next(newProjects);
          location.reload();
            
          })
        }
      })
  }

  public deleteProjectWithConfirmation(project: Project) {
    this.modal
      .open(ConfirmModalComponent, {
        title: "Delete Project",
        body: "Are you sure you want to delete this project?",
        ok: "Delete",
      })
      .afterClosed().pipe(takeUntil(this.unsubscribe$))
      .subscribe((confirmed) => {
        if (!confirmed) return;
        this.projectsApi.delete([project.id]).pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
          this.toast.open("Project deleted");
          const newProjects = [...this.projects$.value];
          newProjects.splice(newProjects.indexOf(project), 1);
          this.projects$.next(newProjects);
          this.shouldShowNewProjectButton = true;
        });
      });
  }

  private bindToProjectFilters() {
    this.projectPaginator = new Paginator<Project>(this.router, this.http);
    this.projectPaginator.dontUpdateQueryParams = true;
    this.projectPaginator.response$.pipe(skip(1)).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (response) => {
        this.loading$.next(false);
        this.projects$.next(response.pagination.data);
      },
      () => this.loading$.next(false)
    );
    this.models.valueChanges
      .pipe(debounceTime(250), distinctUntilChanged()).pipe(takeUntil(this.unsubscribe$))
      .subscribe((params: ProjectFilters) => {
        this.loading$.next(true);
        const merged = {
          ...params,
          user_id: this.currentUser.get("id"),
          per_page: 20,
        };
        this.projectPaginator.paginate(merged, "projects");
      });
  }
}
